import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AppBar from '@material-ui/core/AppBar';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import CloseButton
  from 'Components/UI/Dialog/RefactoredDialog/DialogTitle/Variants/DialogTitleDefault/Actions/CloseButton';

const styles = (theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  facetHeaderBarIcon: {
    alignSelf: 'center',
    width: 35,
    height: 'auto',
  },
  headerBarLeft: {
    position: 'absolute',
    left: 0,
  },
  headerBarRight: {
    position: 'absolute',
    right: theme.spacing(1),
  },
  headerBarCenter: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  facetHeaderBarTitle: {
    textTransform: 'uppercase',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
});

const HeaderBar = ({
  className,
  classes,
  title,
  transparentBackground,
  left,
  right,
  test,
  visible,
  TitleProps,
  onClose,
}) => {
  if (!visible) return null;
  return (
    <AppBar
      className={classNames(classes.root, className)}
      position={'static'}
      color={transparentBackground ? 'transparent' : 'inherit'}
      elevation={0}
      test={test}
    >
      <div className={classes.headerBarLeft}>
        {left}
      </div>
      <div className={classes.headerBarCenter}>
        {title ? (
          <Typography
            className={classes.facetHeaderBarTitle}
            color={transparentBackground ? 'white' : 'textPrimary'}
            variant={'h6'}
            weight={'bold'}
            align={'center'}
            {...TitleProps}
          >
            {title}
          </Typography>
        ) : null
        }
      </div>
      <div className={classes.headerBarRight}>
        {right}
        {onClose && <CloseButton onClose={onClose} />}
      </div>
    </AppBar>
  );
};

HeaderBar.defaultProps = {
  className: '',
  title: null,
  left: null,
  right: null,
  transparentBackground: false,
  test: 'header-bar',
  visible: true,
  TitleProps: {},
  onClose: undefined,
};

HeaderBar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  left: PropTypes.object,
  right: PropTypes.object,
  title: PropTypes.string,
  transparentBackground: PropTypes.bool,
  test: PropTypes.string,
  visible: PropTypes.bool,
  TitleProps: PropTypes.object,
  onClose: PropTypes.func,
};

export default withStyles(styles)(HeaderBar);
